// extracted by mini-css-extract-plugin
export default {"spell24":"Spell_spell24__kPmMR","loading":"Spell_loading__dV-hM"};